'use strict';
// Field and dependency policy is rendered and enforced by the server.
window.dndNextLevel = window.dndNextLevel || {};
